module.exports = __webpack_public_path__ + "img/img21.79e35bb9.svg";